
import axios              from 'axios'
import { mapGetters }      from 'vuex'
export default {
  

  computed: 
  {
    ...mapGetters(['storeId','company',]) , 
  },  
    methods: {
        
        syncStock(stockMovementId)
        {
              const data  = {'stockMovementId' : stockMovementId,'process_env' : process.env.NODE_ENV }
              const url   =  process.env.VUE_APP_ROOT_API1 + 'sync/update_stock'    

                if(this.company.Id == 49 || this.companyId == 26)
                {
                  axios({
                  url    : url,
                  method : "post",
                  data   : data
                  }).then(res => {
                    console.log('SYNC UPDATE.',res.data)
                  }).catch(err => {
                    console.log(err)
                  })

               }
    
        },
         
    }

}